module.exports = __webpack_public_path__ + "static/education-mobile.8371b7a2.webp";